import type { GlobalThemeOverrides } from 'naive-ui'
import { computed, watch } from 'vue'
import { darkTheme, useOsTheme } from 'naive-ui'
import { useAppStore } from '@/store'

export function useTheme() {
  const appStore = useAppStore()

  const OsTheme = useOsTheme()

  const isDark = computed(() => {
    if (appStore.theme === 'auto') {
      return OsTheme.value === 'dark'
    } else {
      return appStore.theme === 'dark'
    }
  })

  const theme = computed(() => {
    return isDark.value ? darkTheme : undefined
  })

  const themeOverrides = computed<GlobalThemeOverrides>(() => {
    if (isDark.value) {
      return {
        common: {},
      }
    }
    return {
      common: {
        primaryColor: '#4050FF',
        primaryColorHover: '#4050FF',
        textColor1: '#0B2C5E',
        textColor2: '#0B2C5E', // radio
        errorColor: '#FF4080',
      },
      Pagination: {
        itemBorder: '1px solid #ECECEC',
        itemTextColor: '#636363',
        itemBorderActive: '1px solid #FF4080',
        itemTextColorHover: '#FF4080',
        itemTextColorActive: '#FF4080',
        itemBorderHover: '1px solid #ECECEC',
        buttonIconColor: '#636363',
        buttonIconColorHover: '#FF4080',
      },
      Button: {
        borderRadiusSmall: '4px',
        borderRadiusTiny: '4px',
        borderRadiusMedium: '4px',
        borderRadiusLarge: '4px',
      },
    }
  })

  watch(
    () => isDark.value,
    (dark) => {
      if (dark) {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    },
    { immediate: true },
  )

  return { theme, themeOverrides }
}
